module.exports = __webpack_public_path__ + "img/agen-pilihan.2b8bbaf6.svg";